// extracted by mini-css-extract-plugin
export var centerToggle = "PageDataBodyTextHeading-module--centerToggle--zK2Ae";
export var heading = "PageDataBodyTextHeading-module--heading--B-n8j";
export var ol = "PageDataBodyTextHeading-module--ol--Ubg10";
export var paragraph = "PageDataBodyTextHeading-module--paragraph--Ou5Q3";
export var richText = "PageDataBodyTextHeading-module--richText--qVxLw";